import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class StyleManagerService {

  addStyle(styleUrl: string) {
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = styleUrl;
    document.head.appendChild(styleLink);
  }
}
